import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
import logo from "../../assets/img/brand/logob.jpg";
import loginimage from "../../assets/img/login.png";
import lvinlogo from "../../assets/img/lvin-logo.png";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions/auth.js";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.checktoken();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    let { email, password } = this.state;
    this.props.login({ email: email, password: password });
  }

  render() {
    let { email, password } = this.state;

    if (this.props.auth.authenticated) return <Redirect to={"/app"} />;

    return (
      <div
        className="app flex-row align-items-center"
        style={{ background: "#FDC858" }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <img src={lvinlogo} />
                      <h4>Manage all of your Group Travel Concerts & Events</h4>
                      <p className="text-muted">
                        Welcome Back, Please login to your account
                      </p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="E-mail"
                          autoComplete="username"
                          name="email"
                          required
                          value={email}
                          onChange={this.handleInputChange}
                        />
                      </InputGroup>
                      <InputGroup className="">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          autoComplete="current-password"
                          name="password"
                          required
                          value={password}
                          onChange={this.handleInputChange}
                        />
                      </InputGroup>
                      <Row>
                        <Col xs="12" className="text-center my-3">
                          <span style={{ color: "red" }}>
                            {this.props.auth.error_message}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <Button
                            color="primary"
                            type="submit"
                            // onClick={this.submit}
                            className="px-4"
                          >
                            Login
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
                <Card
                  className="text-white bg-secondary py-5 d-md-down-none"
                  style={{
                    backgroundImage: `url(${loginimage})`,
                    backgroundSize: "cover",
                  }}
                >
                  <CardBody className="text-center h-100">
                    <div className="row h-100">
                      <div className="col-12 align-self-center">
                        {/*<img src={loginimage} className="mw-100"/>*/}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    auth: state.auth,
  };
}

export default connect(mapStateToProps, actions)(Login);
